<template>
  <div class="footer-wrapper-outer df fdc w100p">
    <div class="footer-wrapper df fdr jcsb aic w100p f1">
      <div class="footer-left f1 df fdc">
<!--         <a class="shop">About Us</a>
        <a class="shop">Our Coffee</a>
        <a class="shop" @click="goTo('/faq')">FAQ</a>
        <a class="shop">Contact Us</a> -->
      </div>
      <div class="footer-right df fdc jcc">
<!--         <p>Stay Connected</p>
        <div class="email-signup df">
          <input type="" name="">
          <button>Sign Up</button>
        </div> -->
      </div>
    </div>
    <div class="footer-below df w100p jcc aic">
      <div class="footer-below-inner df jcc w100p aic">
        <a>© 2021 CupWise</a>
        <div class="f1"></div>
        <a @click="goTo('/contact')">Contact Us</a>
        <a @click="goTo('/privacy')">Privacy Policy</a>
        <a @click="goTo('/terms')">Terms of Service</a>
        <!-- <p>|</p> -->
        <!-- <a>Privacy Policy</a> -->
        <!-- <p>|</p> -->
        <!-- <a>Terms and Conditions</a> -->
        <!-- <p>|</p> -->
        <!-- <a>Cookie Policy</a> -->
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'

export default {
  name: 'Footer',
  data () {
    return {
      some: 'data',
    }
  },
  props: ['mode'],
  components: {
  },
  methods: {
    goTo (path) {
      window.scrollTo(0, 0)
      router.push(path)
    },
  },
  computed: {

  },
  watch: {
  },
  mounted () {
  },
  created () {
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";
  .footer-wrapper-outer {
    height: 37px;
  }
  .footer-wrapper {
    /*background-color: $color-white;*/
    /*height: 240px;*/
    /*min-height: 240px;*/
    /*padding-bottom: 37px;*/
    /*padding-left: 30px;*/
    /*padding-right: 30px;*/
  }
  .footer-right {
    width: 605px;
    /*min-width: 205px;*/
  }
  .footer-below {
    /*position: absolute;*/
    width: 100%;
    /*left: 0;*/
    /*bottom: 0;*/
    height: 37px;
    /*background-color: #444;*/

    .footer-below-inner {
      max-width: $max-width;
      padding-left: 30px;
      padding-right: 30px;
      a {
        color: $color-black;
        font-family: Roboto;
        font-size: 10px;
        letter-spacing: 0;
        line-height: 11px;

        margin-left: 30px;
        margin-right: 30px;

        &:first-child {
          margin-left: 0;
          margin-right: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }


  }
  @media (max-width: 768px) {
  .footer-wrapper-outer {
    height: unset;
  }
    .footer-below {
      position: relative;
      height: unset;
      .footer-below-inner {
        padding-bottom: 15px;
        flex-direction: column;
        & > * {
          font-size: 12px !important;
          margin-left: 0 !important;
          margin-right: 0 !important;
          margin-top: 20px !important;
          margin-bottom: 5px !important;

        }

        & > div {
          display: none;
        }
      }
    }
  }
  p, a, button, input {
    color: $color-black;
  }
  input {
    border: 1.5px solid black;
    width: 310px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Footer.vue